export const professionalExpKeys = {
  last_emp: {
    last_emp_designation: "",
    last_emp_org: "",
    last_emp_from_date: "",
    last_emp_to_date: "",
    last_emp_year_of_experience: "",
    last_emp_reason_for_leaving: "",
    last_emp_salary: "",
    last_emp_supervisor_name: "",
    last_emp_supervisor_designation: "",
    last_emp_supervisor_mobile_no: "",
    filled : 1
  },
  last_to_last_emp: {
    last_to_last_emp_designation: "",
    last_to_last_emp_org: "",
    last_to_last_emp_from_date: "",
    last_to_last_emp_to_date: "",
    last_to_last_emp_year_of_experience: "",
    last_to_last_emp_reason_for_leaving: "",
    last_to_last_emp_salary: "",
    last_to_last_emp_supervisor_name: "",
    last_to_last_emp_supervisor_designation: "",
    last_to_last_emp_supervisor_mobile_no: "",
    filled : 2
  },
  last_to_second_last_emp: {
    last_to_second_last_emp_designation: "",
    last_to_second_last_emp_org: "",
    last_to_second_last_emp_from_date: "",
    last_to_second_last_emp_to_date: "",
    last_to_second_last_emp_year_of_experience: "",
    last_to_second_last_emp_reason_for_leaving: "",
    last_to_second_last_emp_salary: "",
    last_to_second_last_emp_supervisor_name: "",
    last_to_second_last_emp_supervisor_designation: "",
    last_to_second_last_emp_supervisor_mobile_no: "",
    filled : 3
  },
};
